"use client"
import { motion } from "motion/react"
import Icon from "./Icons";
import Link from "next/link";


const FloatingButtons = () => {

    return (
        <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            transition={{ type: "tween", ease: [0.19, 1, 0.22, 1], delay: 2.5 }}

        >
            <div className="fixed right-0 z-[99] space-y-3 translate-x-0 -translate-y-1/2 pointer-events-none top-1/2">
                <div>
                    <Link href={'tel:+4572727256'} className="w-full px-4 py-4  pointer-events-auto gap-6 rounded-l-[4px] justify-start aspect-1 rounded-r-none bg-rød hover:bg-DabraRød ease-in-out transition text-lys block shadow-md">
                        <Icon type={'Telefon'} className="m-auto size-8" />
                    </Link>
                </div>
                <div>
                    <Link href={'mailto:kontakt@danskdkvplan.dk'} className="w-full px-4 py-4  pointer-events-auto gap-6 rounded-l-[4px] justify-start aspect-1 rounded-r-none bg-rød hover:bg-DabraRød ease-in-out transition text-lys block shadow-md">
                        <Icon type={'Besked'} className="m-auto size-8" />
                    </Link>
                </div>
            </div>
        </motion.div>
    );
};

export default FloatingButtons;